var _mask, _g, _mask2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.873779 15.1358C0.873779 23.097 7.1412 29.5939 15.0113 29.9631C15.2456 29.9741 15.4812 29.9803 15.7182 29.9803C19.3691 29.9853 22.8927 28.6396 25.6109 26.2024C23.8711 27.3565 21.8368 28.0203 19.6624 28.0203C16.1274 28.0203 12.9617 26.2668 10.8321 23.5015C9.19094 21.5641 8.12776 18.6997 8.05558 15.4855C8.05536 15.4772 8.05536 14.7945 8.05558 14.7862C8.12776 11.5721 9.19088 8.70783 10.832 6.7705C12.9617 4.00504 16.1274 2.25149 19.6624 2.25149C21.8371 2.25149 23.8719 2.9156 25.6119 4.07002C22.908 1.6453 19.4062 0.300485 15.7743 0.291967C15.7556 0.291903 15.737 0.29126 15.7182 0.29126C7.51986 0.29126 0.873781 6.93737 0.873781 15.1358",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.873779,
    y: 0.29126,
    width: 24.7382,
    height: 29.689,
    fill: "url(#paint0_linear)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 2,
    width: 21,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8319 6.77047C12.1939 5.16254 13.9537 4.19282 15.8757 4.19282C20.1969 4.19282 23.7001 9.09225 23.7001 15.1359C23.7001 21.1795 20.1969 26.079 15.8757 26.079C13.9537 26.079 12.194 25.1092 10.832 23.5014C12.9616 26.2668 16.1273 28.0203 19.6623 28.0203C21.8367 28.0203 23.8711 27.3564 25.6109 26.2024C28.6495 23.4842 30.5626 19.5337 30.5626 15.1358C30.5626 10.7384 28.65 6.78819 25.6119 4.07C23.8718 2.91557 21.8371 2.25146 19.6623 2.25146C16.1273 2.25146 12.9616 4.00502 10.8319 6.77047",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8319,
    y: 2.25146,
    width: 19.7307,
    height: 25.7688,
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.25414,
    y1: 0.775294,
    x2: 1.25414,
    y2: 29.5475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.9507,
    y1: 2.54803,
    x2: 10.9507,
    y2: 27.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.341127b9390f8f11457cb62197f3a62d.svg";
export { ForwardRef as ReactComponent };